import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  SUBSIDY_FILTER_REQUEST,
  SUBSIDY_FILTER_SUCCESS,
  SUBSIDY_FILTER_FAILURE,
  SUBSIDY_FILTER_CLEAR,
  SUBSIDY_FILTER_DELETE,
  SUBSIDY_FILTER_SET,
  SUBSIDY_FILTER_UPDATE,
} from 'app/actions/reports/filters/subsidies';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const subsidies = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SUBSIDY_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case SUBSIDY_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case SUBSIDY_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case SUBSIDY_FILTER_CLEAR: {
      return defaultState;
    }
    case SUBSIDY_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case SUBSIDY_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case SUBSIDY_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default subsidies;
